import type { CompanyDetailsProps } from "@site-types/components/companyDetails"
import Sudoku from "../Sudoku"
import CompanyDetailsTable from "./CompanyDetailsTable"
import CompanyStory from "./CompanyStory"
import CompanyTimeline from "./CompanyTimeline"
import "./styles.css"

export function CompanyDetails({ data }: CompanyDetailsProps) {
  return (
    <div className="company-container">
      <CompanyStory />
      <CompanyTimeline
        historyItems={data.companyHistory}
      />
      <CompanyDetailsTable />
      <Sudoku />
    </div>
  )
}

export default CompanyDetails
